import React from 'react';
import { Box, Typography, Button, styled } from '@mui/material';
import { TripDetail } from '../../types/tripDetail';

const HeaderWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(2),
  backgroundColor: '#252526',
  borderRadius: theme.spacing(1),
  marginBottom: theme.spacing(1.5),
  border: '1px solid rgba(255, 255, 255, 0.1)',
}));

const LeftSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
});

const UserAvatar = styled(Box)({
  width: '32px',
  height: '32px',
  borderRadius: '50%',
  overflow: 'hidden',
  backgroundColor: '#2d2d2d',
  border: '1px solid rgba(255, 255, 255, 0.1)',
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
});

const ActionButtons = styled(Box)({
  display: 'flex',
  gap: '8px',
});

const StyledButton = styled(Button)({
  textTransform: 'none',
  borderRadius: '4px',
  padding: '6px 16px',
  backgroundColor: '#99C5FF',
  color: '#000',
  fontWeight: 500,
  '&:hover': {
    backgroundColor: '#7DB1FF',
  },
});

interface TripDetailPanelHeaderProps {
  tripDetail: TripDetail;
  onAssignToSelf?: () => void;
  onAssignOperator?: () => void;
}

const TripDetailPanelHeader: React.FC<TripDetailPanelHeaderProps> = ({
  tripDetail,
  onAssignToSelf,
  onAssignOperator,
}) => {
  return (
    // <HeaderWrapper>
      <LeftSection>
        {/* <Box>
          <Typography variant="h6" sx={{ color: '#fff', fontSize: '1rem', fontWeight: 500 }}>
            Trip Details
          </Typography>
        </Box>
        {tripDetail.assignedTo && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <UserAvatar>
              <img src={tripDetail.assignedTo.avatar} alt={tripDetail.assignedTo.name} />
            </UserAvatar>
            <Typography sx={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '0.875rem' }}>
              {tripDetail.assignedTo.name}
            </Typography>
          </Box>
        )} */}
      </LeftSection>
    // </HeaderWrapper>
  );
};

export default TripDetailPanelHeader;
